export default "__VITE_ASSET__B9WQZxCX__"